import { attr, belongsTo } from '@ember-data/model';
import Enum from '@square/dashboard-utilities/utils/enum';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
import { fragment, fragmentArray } from 'ember-data-model-fragments/attributes';
import { computed } from '@ember/object';
import Money from '@square/dashboard-money/models/money';
export const OrderState = new Enum(['DO_NOT_USE', 'OPEN', 'COMPLETED', 'CANCELED', 'DRAFT']);

// A subset of Orders' Order model as an Ember-data model containing only the properties
// used by Subscriptions.

export default EmberDataBaseModel.extend({
  subscription: belongsTo('buyer-sub'),
  locationId: attr('string'),
  customerId: attr('string'),
  version: attr('number'),
  state: attr('enum', {
    enumClass: OrderState
  }),
  lineItems: fragmentArray('subscription-order-line-item', {
    defaultValue: []
  }),
  totalTaxMoney: attr('money-proto', {
    readOnly: true
  }),
  totalDiscountMoney: attr('money-proto', {
    readOnly: true
  }),
  totalMoney: attr('money-proto', {
    readOnly: true
  }),
  taxes: fragmentArray('subscription-order-price-modifier', {
    defaultValue: []
  }),
  discounts: fragmentArray('subscription-order-price-modifier', {
    defaultValue: []
  }),
  serviceCharges: fragmentArray('subscription-order-price-modifier', {
    defaultValue: []
  }),
  fulfillments: fragmentArray('subscriptions/fulfillment', {
    defaultValue: []
  }),
  pricingOptions: fragment('pricing-options', {
    defaultValue: {}
  }),
  // Taking this logic from Invoice Manager's cart-presenter
  subtotal: computed('', 'lineItems', 'totalDiscountMoney', function () {
    return (this.lineItems ?? []).reduce((subtotal, lineItem) => {
      return subtotal.add(lineItem.grossSalesMoney);
    }, Money.zero()).subtract(this.totalDiscountMoney ?? Money.zero());
  })
}).reopenClass({
  OrderState,
  _modelNameForMigration: 'subscription-order-template'
});